export default {
    current_choice: 'Choix actuel',
    book_now: 'Réservez maintenant',
    minimum_age: 'Réservé aux plus de {age} ans',
    excess_liability: 'Responsabilité en cas de dommage',
    security_deposit: 'Dépôt de garantie',
    fuel_policy: 'Politique de carburant',
    like_for_like: 'Plein à plein',
    full_to_full: 'Plein à plein',
    miles_per_rental: '{mileage} miles gratuits par location',
    km_per_rental: '{mileage} km gratuits par location',
    unlimited_mileage: 'Kilométrage illimité',
    unlimited_mileage_km: 'Km illimités',
    non_amendable: 'Non modifiable',
    non_refundable: 'Non remboursable',
    free_cancellation_until: "Annulation gratuite jusqu'à",
    basic_free_cancellation: 'Annulation gratuite jusqu’à 48 heures avant l’heure de début',
    cancellation_in_line_with: 'Annulation conforme à',
    tcs: 'C&amp;GV',
    free_extras_on_collection: 'Deux extras gratuits à la collecte',
    glass_and_tyres_covered: 'Vitres et pneus couverts',
    number_of_passengers: 'Nombre de passagers',
    number_of_bags: 'Nombre de bagages',
    fuel_type: 'Type de carburant',
    co2: 'CO2',
    aircon: 'Climatisation',
    transmission: 'Transmission',
    book_type: 'Réserver {type}',
    debit_card_deposit: 'Carte de débit acceptée pour les dépôts',
    fast_track_included: 'Accès rapide inclus',
    view_all: 'Tout afficher',
};
